import { I18n } from "i18n-js";
import en from "./locales.en.json";
import sv from "./locales.sv.json";

const translations = {
  en,
  sv,
};

const locale = window?.locale || "sv";
const i18n = new I18n(translations[locale]);
i18n.locale = locale;

export default i18n;
